import styled, { css } from '@eduzz/houston-styles/styled';
import '@fontsource/roboto';
import '@fontsource/lato';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 250px auto;
  height: calc(100vh - 35px);

  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.md}) {
      grid-template-columns: auto;
      height: auto;
    }
  `}
`;

export const Content = styled.main`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: scroll;
  padding: 24px 0;
  box-sizing: border-box;

  ${({ theme }) => css`
  @media only screen and (max-width: ${theme.breakpoints.md}) {
    padding-bottom: ${theme.spacing.xl};
  `}
`;
